export default values => ({
    error: Object.keys(values).length === 0 ? "Required description or Photo" : "",
});
